import { Prisma } from "@prisma/client";
import { fileSelectValues } from "./file.types";
import { PaginatedResponse } from "./utils.types";

export type ProductsResponse = PaginatedResponse<ProductType> & {
  structureId: string;
};

export type EventProductsResponse = {
  structureId: string;
  products: ProductType[];
};

export const productTypeValue =
  Prisma.validator<Prisma.StructureProductDefaultArgs>()({
    include: {
      images: {
        select: {
          file: {
            select: fileSelectValues,
          },
        },
        orderBy: {
          order: "asc",
        },
      },
    },
  });

export type ProductType = Prisma.StructureProductGetPayload<
  typeof productTypeValue
>;

export type NewProduct = {
  name: string;
};

export type OldProduct = {
  id: string;
};

export type FilterProductType = {
  searchText?: string;
};
